import { render } from "./ExpenseHistory.vue?vue&type=template&id=c758a2b8&scoped=true"
import script from "./ExpenseHistory.vue?vue&type=script&lang=js"
export * from "./ExpenseHistory.vue?vue&type=script&lang=js"

import "./ExpenseHistory.vue?vue&type=style&index=0&id=c758a2b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c758a2b8"]])

export default __exports__